module.exports = __webpack_public_path__ + "static/media/5.e3944a87.jpg";